import { Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslate } from "../../../hooks/useTranslate";
import "./NotFound.css";

const NotFound = () => {
    const { t } = useTranslate();
    const navigate = useNavigate();

    const handleGoHome = () => {
        navigate("/", { replace: true });
    };

    return (
        <div className="NotFound">
            <Typography variant="h1">{t("errorPage.oops")}</Typography>
            <Typography variant="h3">{t("errorPage.notFound")}</Typography>
            <Button
                variant="outlined"
                size="small"
                onClick={handleGoHome}
                className="NotFound__button"
            >
                {t("errorPage.backToHome")}
            </Button>
        </div>
    );
};

export default NotFound;
